import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Rodeo } from 'src/models/rodeo';
import { BehaviorSubject } from 'rxjs';
import { Organization } from 'src/models/organization';
import { Arena } from 'src/models/arena';
import { RoundStyle } from 'src/models/roundStyle';
import {PayoutConfig} from "../models/payoutConfig";
import {PayoutSource} from "../models/payout-source";
import {RodeoPayoutConfig} from "../models/rodeoPayoutConfig";
import { Account } from 'src/models/account.model';
import { RodeoEvent } from 'src/models/rodeoEvent';

@Injectable({
  providedIn: 'root',
})
export class RodeoService {
  public selectedRodeo = new BehaviorSubject<Rodeo | undefined>(undefined);

  constructor(private api: ApiService) {}

  async searchRodeos(searchOptions: any) {
    return await this.api.post<any[]>(
      `${this.api.endpoints.rodeos}/searchRodeos`,
      searchOptions,
    );
  }

  async getRodeo(id: number) {
    return await this.api.get<any>(`${this.api.endpoints.rodeos}/get?id=${id}`);
  }

  async updateRodeo(data: any) {
    return this.api.post(this.api.endpoints.rodeos + '/update?id=' + data.id, data)
  }

  async createRodeo(data: any) {
    return this.api.post(this.api.endpoints.rodeos + '/create', data)
  }

  async getSettingOptions() {
    return await this.api.get<{
      organizations: Organization[];
      arenas: Arena[];
      roundStyles: RoundStyle[];
    }>(`${this.api.endpoints.rodeos}/getSettingOptions`);
  }

  async updatePayoutConfig(payoutConfig: PayoutConfig) : Promise<any> {
    return await this.api.post<any>(`${this.api.endpoints.rodeos}/updatePayoutConfig`, payoutConfig);
  }

  async updatePayoutSource(payoutSource: PayoutSource) : Promise<PayoutSource> {
    return await this.api.post<PayoutSource>(`${this.api.endpoints.rodeos}/updatePayoutSource`, payoutSource);
  }

  async getEventTypes(): Promise<string[]> {
    return this.api.get(this.api.endpoints.rodeoEvents + '/getEventTypes');
  }

  async deletePayoutConfig(payoutConfig: RodeoPayoutConfig) : Promise<RodeoPayoutConfig> {
    return await this.api.post<RodeoPayoutConfig>(`${this.api.endpoints.rodeos}/deletePayoutConfig?payoutConfigId=${payoutConfig.id}`, {});
  }

  async addPayoutConfig(payoutConfig: any) : Promise<RodeoPayoutConfig> {
    return await this.api.post<RodeoPayoutConfig>(`${this.api.endpoints.rodeos}/addPayoutConfig`, payoutConfig);
  }

  async getContestants(searchOptions: any) {
    return await this.api.post<Account[]>(
      `${this.api.endpoints.rodeos}/searchContestants`,
      searchOptions,
    );
  }

  async getRodeoEvents(rodeoId: number): Promise<any[]> {
    return await this.api.get(this.api.endpoints.rodeoEvents + '/getAllForRodeo?rodeoId=' + rodeoId);
  }

  async getRodeosEvents(rodeoIds: number[]) {
    return this.api.post<RodeoEvent[]>(`${this.api.endpoints.rodeoEvents}/getAllForRodeos`, rodeoIds);
  }
}
